import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { IButtonActionComponent, IButtonActionPresenter } from './interfaces';

@Injectable({ providedIn: 'root' })
export class ButtonActionPresenter
	extends IAbstractPresenter<IButtonActionComponent>
	implements IButtonActionPresenter
{
	buttonActionIcon: string = '';
	effect: string = '';
	translations: ILanguageObject = {};

	loading$: Observable<boolean> = of(false);
	disabled: boolean = false;
	text: string | null = null;
	textRight: string | null = null;
	icon: string | null = null;
	buttonClick: EventEmitter<void> = new EventEmitter<void>();

	constructor() {
		super();
	}

	override onAfterViewInit(): void {
		this.cdr.detectChanges();
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	hasTwoTexts(): boolean {
		return this.view.textRight !== null && this.view.textRight !== '';
	}

	onButtonClick(): void {
		this.view.buttonClick.emit();
	}
}
